<template>
  <div>
    <div aria-label="Toolbar with button groups">
      <div aria-label="search tool" role="group" class="input-group">
        <input
          v-model="search"
          type="text"
          placeholder="Buscar"
          autocomplete="off"
          class="form-control form-control-sm"
        />
        <div class="input-group-append">
          <button
            type="button"
            class="btn search-icon btn-sm btn-toolbar"
            :class="`btn-${search ? 'danger' : 'light'}`"
            @click="handleClick"
          >
            <stop-search-icon class="icon" title="Buscar" v-if="search" />
            <search-icon class="icon" title="Limpar busca" v-else />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      // search: ""
    };
  },
  methods: {
    handleClick() {
      if (this.search) {
        this.search = "";
      } else {
        this.$emit("input", this.search);
      }
    },
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  // watch: {
  //   search: {
  //     handler(newValue) {
  //       this.$emit('input', newValue);
  //     },
  //   }
  // }
};
</script>

<style scoped>
.search-icon.btn-light {
  filter: brightness(0.9);
}
.icon {
  font-size: 1em;
}
</style>
